import { render } from "./DottedValue.vue?vue&type=template&id=3966d2dc"
import script from "./DottedValue.vue?vue&type=script&lang=js"
export * from "./DottedValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__